<template>
  <sdPageHeader class="header-boxed" :title="$t('pages.sale-performance.title')">
  </sdPageHeader>
  <Main class="grid-boxed">
    <a-row :gutter="25">
      <a-col :lg="8" :xs="24" v-for="(item, index) in cards" :key="index">
          <SimpleCardVue
            :text="item.text"
            :imgSrc="require('@/' + item.imgSrc)"
            :endpoint="item.endpoint"
            :currency="item.currency"
          />
        </a-col>
      <a-col :lg="24" :xs="24">
        <Suspense>
          <template #default>
            <RecentOrder />
          </template>
          <template #fallback>
            <sdCards headless>
              <a-skeleton active />
            </sdCards>
          </template>
        </Suspense>
      </a-col>
    </a-row>
  </Main>
</template>
<script>
import { CardBarChart2, OverviewSalesCard } from './style';
import { Main } from '../styled';
import { defineAsyncComponent } from 'vue';
import SvgConverter from '@/components/utilities/SvgConverter.vue';
import SimpleCardVue from '@/components/cards/SimpleCard.vue';

const RecentOrder = defineAsyncComponent(() => import('./overview/RecentOrder'));

const Sales = {
  name: 'Sales',
  components: {
    Main,
    CardBarChart2,
    OverviewSalesCard,
    RecentOrder,
    SvgConverter,
    SimpleCardVue
  },
  data() {
    return {
      cards: [
        {
          text: this.$t('pages.sale-performance.total'),
          imgSrc: 'static/img/icon/NewCustomer.svg',
          endpoint: this.$endpoints.sale_perf_total,
          currency: "TL"
        },
        {
          text: this.$t('pages.sale-performance.undrawn'),
          imgSrc: 'static/img/icon/NewCustomer.svg',
          endpoint: "0",
          currency: "TL"
        },
        {
          text: this.$t('pages.sale-performance.drawn'),
          imgSrc: 'static/img/icon/NewCustomer.svg',
          endpoint: "0",
          currency: "TL"
        },
      ],
    };
  }
};

export default Sales;
</script>
